var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.717 1.823a1.933 1.933 0 100 3.866 1.933 1.933 0 000-3.866zM8.844 3.168a2.934 2.934 0 11-.03 1H.5a.5.5 0 110-1h8.344zm6.33.088H18.5a.5.5 0 110 1h-3.326v-1zM6.26 8.31a1.933 1.933 0 100 3.866 1.933 1.933 0 000-3.866zM3.37 9.744a2.934 2.934 0 110 1H.5a.5.5 0 010-1H3.37zM18.5 10.83H9.914v-1H18.5a.5.5 0 010 1z",
    fill: "#1C1C1C"
  })));
}
export default SvgFilterIcon;